var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationtypeMisc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_di_10519_44081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 24.668C44 35.7137 27.017 51.3346 24 51.3346C20.983 51.3346 4 35.7137 4 24.668C4 13.6223 12.9543 4.66797 24 4.66797C35.0457 4.66797 44 13.6223 44 24.668Z",
    fill: "#8FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24Z",
    fill: "#C7DFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8588 20.0625L29.2338 17.5H18.7651L17.1401 20.0625C16.9838 20.3438 16.9526 20.7188 17.0776 21C17.2026 21.2812 17.4213 21.4688 17.7026 21.5C17.7651 21.5 17.8276 21.5312 17.8901 21.5312C18.2651 21.5312 18.5776 21.3438 18.7963 21.0938C19.1088 20.7812 19.4838 20.625 19.9213 20.625C20.3588 20.625 20.7651 20.7812 21.0463 21.0938C21.2651 21.3438 21.5776 21.5312 21.9526 21.5312C22.3276 21.5312 22.6713 21.3438 22.8901 21.0938C23.1713 20.7812 23.5776 20.625 23.9838 20.625C24.4213 20.625 24.8276 20.7812 25.1088 21.0938C25.3276 21.3438 25.6713 21.5312 26.0463 21.5312C26.4213 21.5312 26.7338 21.3438 26.9526 21.0938C27.2338 20.7812 27.6401 20.625 28.0776 20.625C28.4838 20.625 28.8901 20.7812 29.1713 21.0938C29.4213 21.3438 29.7338 21.5 30.1088 21.5C30.1713 21.5 30.2338 21.5 30.2963 21.5C30.5776 21.4688 30.7963 21.2812 30.9213 21C31.0463 20.6875 31.0151 20.3438 30.8588 20.0625ZM30.1088 23C29.4838 23 28.9213 22.8125 28.4838 22.4688C28.3276 22.375 28.2026 22.25 28.0776 22.0938C27.9526 22.25 27.8276 22.375 27.6713 22.4688C27.2026 22.8125 26.6401 23 26.0463 23C25.4213 23 24.8588 22.8125 24.4213 22.4688C24.2651 22.375 24.1088 22.25 23.9838 22.0938C23.8588 22.25 23.7338 22.375 23.5776 22.4688C23.1401 22.8125 22.5776 23 21.9526 23C21.3588 23 20.7963 22.8125 20.3276 22.4688C20.1713 22.375 20.0463 22.25 19.9213 22.125C19.7963 22.25 19.6713 22.375 19.5151 22.4688C19.0463 22.8125 18.4838 23 17.8901 23C17.7651 23 17.6401 23 17.5151 23C15.7651 22.75 14.9526 20.7188 15.8901 19.25L17.6713 16.4375C17.8276 16.1562 18.1088 16 18.4213 16H29.5776C29.8901 16 30.1713 16.1562 30.3276 16.4375L32.1088 19.25C33.0463 20.7188 32.2338 22.75 30.4838 23C30.3588 23 30.2338 23 30.1088 23ZM18.5151 26.5H29.5151V23.9688C29.7026 24 29.8901 24 30.1088 24C30.2651 24 30.4526 24 30.6088 23.9688C30.7651 23.9688 30.8901 23.9375 31.0151 23.9062V26.5V28V30C31.0151 31.125 30.1088 32 29.0151 32H19.0151C17.8901 32 17.0151 31.125 17.0151 30V28V26.5V23.9062C17.1088 23.9375 17.2338 23.9688 17.3901 23.9688C17.5463 24 17.7026 24 17.8901 24C18.1088 24 18.2963 24 18.5151 23.9688V26.5ZM29.5151 28H18.5151V30C18.5151 30.2812 18.7338 30.5 19.0151 30.5H29.0151C29.2651 30.5 29.5151 30.2812 29.5151 30V28Z",
    fill: "#417D8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_10519_44081",
    x: -2,
    y: -1,
    width: 52,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.152941 0 0 0 0 0.0862745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10519_44081"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10519_44081",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.152941 0 0 0 0 0.0862745 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_10519_44081"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationtypeMisc);
export default __webpack_public_path__ + "static/media/organizationtype-misc.390d1f3e83a60fea9c885a3c82e5e28b.svg";
export { ForwardRef as ReactComponent };